import { StyleSheet } from 'react-native';

import { THEME } from '../../common';

const { COLOR, SPACE } = THEME;

export default StyleSheet.create({
  container: {
    marginBottom: SPACE.XS,
    color: COLOR.TEXT,
  },
});
